<!--File: cgp-user-profile-dialog.template.html-->
<!--Author: James Seebach-->
<!--Date: 4/27/2017-->
<!--Desc: CGP User Profile Dialog contents.-->
<!--Other Contributors:-->

<h1 mat-dialog-title>{{title}}</h1>

<div i18n mat-dialog-content>
    <div>
        <b>Name: </b>{{getUserProfile()?.fullName}}
    </div>
    <div>
        <b>GMIN: </b>{{getUserProfile()?.gmin}}
    </div>
    <div>
        <b>Role: </b>{{getUserRole() | async}}
    </div>
</div>

<div mat-dialog-actions class="cgp-dialog-actions">
    <span class="cgp-flex-fill"></span>
    <button mat-button mat-raised-button mat-dialog-close>{{ closeLabel }}</button>
</div>